import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CareerPlanLevel } from 'src/app/models/career-plans';
import { CareerPlansFacade } from '../../../../state/career-plans/career-plans.facade';

@Component({
  selector: 'app-level-card',
  templateUrl: './level-card.component.html',
  styleUrls: ['./level-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LevelCardComponent {
  unfolded: boolean;
  isOpen = false;
  currentlyOpenedItemIndex = -1;

  @Input()
  levels: CareerPlanLevel[];

  @Input()
  levelInProgress: CareerPlanLevel;

  constructor(private readonly careerPlansFacade: CareerPlansFacade) {}

  ngOnInit() {
    this.sortResourcesObligatory();
  }

  private sortResourcesObligatory() {
    this.levelInProgress?.resourcesObligatory.sort((a, b) => {
      if (a.order == null) {
        return 1;
      }

      if (b.order == null) {
        return -1;
      }

      if (a.order < b.order) {
        return -1;
      }

      if (a.order > b.order) {
        return 1;
      }

      return 0;
    });
  }

  setOpened(itemIndex, level: CareerPlanLevel) {
    this.currentlyOpenedItemIndex = itemIndex;
    this.isOpen = true;
    this.careerPlansFacade.setLevel(level);
  }

  setClosed(itemIndex) {
    if (this.currentlyOpenedItemIndex === itemIndex) {
      this.currentlyOpenedItemIndex = -1;
    }
  }

  expandContentByIndex(itemIndex) {
    return itemIndex === this.currentlyOpenedItemIndex ? true : false;
  }

  expandLevelInProgress(levelId: string) {
    if (this.careerPlansFacade.selectedLevel) {
      return this.careerPlansFacade.selectedLevel.levelId === levelId;
    }

    return this.levelInProgress ? levelId === this.levelInProgress.levelId : false;
  }
}
